var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.5,
    r: 18,
    fill: "#0368A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1705 11.6402C28.5297 11.9994 28.7885 12.4464 28.9212 12.9367C29.6852 16.012 29.5087 20.8691 28.936 24.0631C28.8033 24.5534 28.5445 25.0005 28.1853 25.3596C27.8261 25.7188 27.3791 25.9777 26.8888 26.1103C25.0937 26.5999 17.869 26.5999 17.869 26.5999C17.869 26.5999 10.6443 26.5999 8.84921 26.1103C8.35888 25.9777 7.91185 25.7188 7.55266 25.3596C7.19347 25.0005 6.93464 24.5534 6.80196 24.0631C6.0335 21.0011 6.24416 16.1411 6.78713 12.9516C6.91981 12.4612 7.17863 12.0142 7.53783 11.655C7.89702 11.2958 8.34404 11.037 8.83438 10.9043C10.6294 10.4147 17.8542 10.3999 17.8542 10.3999C17.8542 10.3999 25.0789 10.3999 26.8739 10.8895C27.3643 11.0221 27.8113 11.281 28.1705 11.6402ZM21.5481 18.4999L15.5547 21.9713V15.0285L21.5481 18.4999Z",
    fill: "#E4F2FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.53ac84c4132538bc287274640dde42a7.svg";
export { ForwardRef as ReactComponent };